import { useNavigate } from "react-router";

import Cookies from "universal-cookie";
const cookies = new Cookies();

const TopContainer = ({ username, title, getMenuOptions }) => {
    const navigate = useNavigate();
    const menuSubOptions = getMenuOptions();
    let userLogo = cookies.get("userLogo");

    const subMenuDisply =
        menuSubOptions.length > 0 && menuSubOptions[0] !== null ? (
            <>
                <div className="topNavBarContainer">
                    <ul className="topNavbar">{getMenuOptions()}</ul>
                </div>
            </>
        ) : (
            <></>
        );

    return (
        <div className="containerTopBar">
            <div className="containterTop">
                <div className="TopBar">
                    <div className="topBarTopWraper">
                        <div
                            className="titleAndBrandingContainer"
                            onClick={() => navigate("/dashboard")}
                        >
                            <h1 className="topBarBranding">
                                STREAM{" "}
                                <span className="topBarBranding2">MEMES</span>
                            </h1>
                            <h1 className="topTitleText">{title}</h1>
                        </div>

                        <div className="topBarTitleBar"></div>

                        <div
                            className="usernameContainer"
                            onClick={() =>
                                navigate("/dashboard/settings/accountsettings")
                            }
                        >
                            <div className="logoTopBarContainer">
                                <img
                                    src={userLogo}
                                    className="userLogoMenu"
                                    alt="logoUser"
                                />
                            </div>
                            <h4 className="userNameDisplay">{username}</h4>
                        </div>
                    </div>
                </div>
            </div>
            {subMenuDisply}
        </div>
    );
};

export default TopContainer;
